import {
  ADD_USER_TABS,
  REMOVE_USER_TABS,
  SET_ACTIVE_USER,
  SET_EXPANDED_USER_TAB,
  CLEAN_EXPANDED_USER_TAB,
  CLOSE_ALL_TABS,
  UPDATE_USER_TABS,
  SET_ACTIVE_CHANNEL
} from '../types/tabs'

export const addUserTab = (user, channel) => ({
  type: ADD_USER_TABS,
  user, channel
})

export const removeUserTab = (user) => ({
  user,
  type: REMOVE_USER_TABS,
})

export const setActiveUser = (user) => ({
  user,
  type: SET_ACTIVE_USER,
})

export const setActiveChannel = (channel) => ({
  user: '', channel,
  type: SET_ACTIVE_CHANNEL,
})

export const setExpandedUserTab = (user) => ({
  user,
  type: SET_EXPANDED_USER_TAB
})

export const cleanExpandedUserTab = (user) => ({
  user,
  type: CLEAN_EXPANDED_USER_TAB
})

export const closeAllTabs = () => ({
  user: '',
  type: CLOSE_ALL_TABS,
})

export const removeUserTabs = (user) => (dispatch) => dispatch(removeUserTab(user))

export const updateUserTabs = ({ users, user }) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_TABS,
    users,
    user,
  })
}
